import axios from "../../../util/axios";

export async function getCancelReasons() {
  try {
    const res = await axios.get(`/admin/v1/clinic/cancel-reasons`);
    const raw = res?.data?.data ?? res?.data ?? [];
    const items = Array.isArray(raw) ? raw : [];
    return items
      .map((item) => {
        if (!item || !item.id) return null;
        const value = item.id;
        const reasonText = item?.reason?.en || item?.reason?.ar;
        const label = reasonText || String(item.id);
        return { value: String(value), label: String(label) };
      })
      .filter(Boolean);
  } catch (error) {
    console.error("Error fetching cancel reasons:", error);
    throw error;
  }
}
